import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import { showOwnershipModal, takeQueueItem, getStorageSetting } from 'actions';

class FormViewRedirectButton extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    formId: PropTypes.number.isRequired,
    accountId: PropTypes.number,
    form: PropTypes.shape().isRequired,
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    accountId: null,
    permissions: null,
    title: '',
    className: '',
    disabled: false
  };

  static isUserFormOwner(user) {
    const loggedOnUser = getStorageSetting('username');

    return (loggedOnUser != null && user != null && loggedOnUser === user);
  }

  static showModal = (permissions, form) => {
    if (form != null && (form.workflowStatus != null || form.workflowStageDescription != null) && form.workflowUsername != null) {
      let wfStatus = form.workflowStatus ? form.workflowStatus.toLowerCase() : null;
      wfStatus = !wfStatus && form.workflowStageDescription ? form.workflowStageDescription.toLowerCase() : wfStatus;
      const hasHigherPermission = AccessControl.hasPermission(permissions, [ActivityPerms.fwfExpertReviewer, ActivityPerms.fwfSupplReviewer]);

      if (wfStatus.includes('initial')) {
        return AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer]) && hasHigherPermission;
      }

      if (wfStatus.includes('secondary')) {
        return AccessControl.hasPermission(permissions, [ActivityPerms.fwfSecondaryReviewer]) && hasHigherPermission;
      }

      if (wfStatus.includes('expert')) {
        return AccessControl.hasPermission(permissions, [ActivityPerms.fwfExpertReviewer]);
      }
    }
    return false;
  };

  onClick(history) {
    const { dispatch, formId, accountId, form, permissions } = this.props;
    if (formId == null || form == null || (form.workflowStatus == null && form.workflowStageDescription == null) || form.workflowUsername == null) {
      return;
    }

    let wfStatus = form.workflowStatus ? form.workflowStatus.toLowerCase() : null;
    wfStatus = !wfStatus && form.workflowStageDescription ? form.workflowStageDescription.toLowerCase() : wfStatus;

    let formUrl = `/forms/${ form.formType.toLowerCase() }/${ formId }`;
    if (accountId && accountId > 0) {
      formUrl = `${ formUrl }?account=${ accountId }`;
    }

    if (FormViewRedirectButton.isUserFormOwner(form.workflowUsername) || wfStatus === 'complete') {
      history.push(formUrl);
    } else if (FormViewRedirectButton.showModal(permissions, form)) {
      dispatch(showOwnershipModal({
        id: formId,
        accountId: form.accountId,
        formType: form.formType.toLowerCase(),
        currentUser: form.workflowUsername,
        currentUserFullName: form.workflowUserFullName
      }));
    } else {
      if (wfStatus.includes('initial') && AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer])) {
        dispatch(takeQueueItem('form', formId, form.accountId));
      }

      if (wfStatus.includes('secondary') && AccessControl.hasPermission(permissions, [ActivityPerms.fwfSecondaryReviewer])) {
        dispatch(takeQueueItem('form', formId, form.accountId));
      }

      if (wfStatus.includes('expert') && AccessControl.hasPermission(permissions, [ActivityPerms.fwfExpertReviewer])) {
        dispatch(takeQueueItem('form', formId, form.accountId));
      }
      history.push(formUrl);
    }
  }

  render() {
    const { className, content, title, disabled } = this.props;
    return <Route
      render={ ({ history }) => (
        <button
          type="button"
          className={ `btn btn-redirect ${ className }` }
          onClick={ () => this.onClick(history) }
          title={ title }
          disabled={ disabled }
        >
          { content }
        </button>
      ) }
    />;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const FormViewButton = connect(
  null,
  mapDispatchToProps
)(FormViewRedirectButton);

export default FormViewButton;
